// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"1b162643","977":"e7de66aa"}[chunkId] + ".chunk.js";
};